import { AccessDecisionStrategy } from '~/common/types';

export const FEATURES = {
  QUOTE: 'QUOTE_FEATURE',
  REDISTRIBUTION: 'REDISTRIBUTION_FEATURE',
  QUOTE_EXPRESS: 'QUOTE_EXPRESS_FEATURE',
  CHAT: 'CHAT_FEATURE',
  CONTAINER: 'CONTAINER_FEATURE',
  EXTRA_BONUS: 'EXTRA_BONUS_FEATURE',
  DESTOCKING: 'DESTOCKING_FEATURE',
} as const;

export const GROUPS = {
  GROUP_WTB_BASE: 'WTB_BASE',
  GROUP_SUPERADMIN: 'SUPERADMIN',
  GROUP_IAM_ADMIN: 'IAM_ADMIN',
  GROUP_PLATFORM_SETUP: 'PLATFORM_SETUP',
  GROUP_SUPPORT: 'SUPPORT',
  GROUP_CUSTOMER_RELATIONSHIP: 'CR',
  GROUP_MARKETING: 'MARKETING',
  GROUP_CALL_CENTER: 'CALL_CENTER',
  GROUP_PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  GROUP_CUSTOMER_MANAGER: 'CUSTOMER_MANAGER',
  GROUP_CONSULTANT: 'CONSULTANT',
  GROUP_BUYER: 'BUYER',
  GROUP_SELLER: 'SELLER',
  GROUP_REDISTRIBUTION_PRICING_POLICY: 'REDISTRIBUTION_PRICING_POLICY',
  GROUP_QUOTE: 'QUOTE',
  GROUP_ADVANCED_QUOTE: 'ADVANCED_QUOTE',
  GROUP_QUOTE_SETTINGS: 'QUOTE_SETTINGS',
  GROUP_REDISTRIBUTION_IMPORT: 'REDISTRIBUTION_IMPORT',
  GROUP_CONTAINER_SUPPLIER: 'CONTAINER_SUPPLIER',
  GROUP_CONTAINER_BUYER: 'CONTAINER_BUYER',
  GROUP_PURCHASE_ADMIN: 'PURCHASE_ADMIN',
};

export const WYZ_GROUPS = [
  GROUPS.GROUP_SUPERADMIN,
  GROUPS.GROUP_IAM_ADMIN,
  GROUPS.GROUP_PLATFORM_SETUP,
  GROUPS.GROUP_SUPPORT,
  GROUPS.GROUP_CUSTOMER_RELATIONSHIP,
  GROUPS.GROUP_MARKETING,
];

export const ROLES = {
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN', // omnipotent role

  // BRAND TEMPLATES

  ROLE_BRAND_TEMPLATE_LIST: 'ROLE_BRAND_TEMPLATE_LIST',
  ROLE_BRAND_TEMPLATE_GET: 'ROLE_BRAND_TEMPLATE_GET',
  ROLE_BRAND_TEMPLATE_CREATE: 'ROLE_BRAND_TEMPLATE_CREATE',
  ROLE_BRAND_TEMPLATE_UPDATE: 'ROLE_BRAND_TEMPLATE_UPDATE',
  ROLE_BRAND_TEMPLATE_DELETE: 'ROLE_BRAND_TEMPLATE_DELETE',

  // QUOTE BRAND TEMPLATES

  ROLE_QUOTE_BRAND_TEMPLATE_LIST: 'ROLE_QUOTE_BRAND_TEMPLATE_LIST',
  ROLE_QUOTE_BRAND_TEMPLATE_GET: 'ROLE_QUOTE_BRAND_TEMPLATE_GET',
  ROLE_QUOTE_BRAND_TEMPLATE_CREATE: 'ROLE_QUOTE_BRAND_TEMPLATE_CREATE',
  ROLE_QUOTE_BRAND_TEMPLATE_UPDATE: 'ROLE_QUOTE_BRAND_TEMPLATE_UPDATE',
  ROLE_QUOTE_BRAND_TEMPLATE_DELETE: 'ROLE_QUOTE_BRAND_TEMPLATE_DELETE',

  // REDISTRIBUTION BRAND TEMPLATES

  ROLE_REDISTRIBUTION_BRAND_TEMPLATE_LIST:
    'ROLE_REDISTRIBUTION_BRAND_TEMPLATE_LIST',
  ROLE_REDISTRIBUTION_BRAND_TEMPLATE_GET:
    'ROLE_REDISTRIBUTION_BRAND_TEMPLATE_GET',
  ROLE_REDISTRIBUTION_BRAND_TEMPLATE_CREATE:
    'ROLE_REDISTRIBUTION_BRAND_TEMPLATE_CREATE',
  ROLE_REDISTRIBUTION_BRAND_TEMPLATE_UPDATE:
    'ROLE_REDISTRIBUTION_BRAND_TEMPLATE_UPDATE',
  ROLE_REDISTRIBUTION_BRAND_TEMPLATE_DELETE:
    'ROLE_REDISTRIBUTION_BRAND_TEMPLATE_DELETE',

  // CREATE CUSTOMER
  ROLE_CUSTOMER_CREATE: 'ROLE_CUSTOMER_CREATE',
  ROLE_FORCEFULLY_CREATE_CUSTOMER: 'ROLE_FORCEFULLY_CREATE_CUSTOMER',
  ROLE_CUSTOMER_LIST: 'ROLE_CUSTOMER_LIST',
  ROLE_CUSTOMER_CHILDREN_LIST: 'ROLE_CUSTOMER_CHILDREN_LIST',
  ROLE_CUSTOMER_UPDATE_STATUS_N1: 'ROLE_CUSTOMER_UPDATE_STATUS_N1',
  ROLE_CUSTOMER_UPDATE_STATUS_N2: 'ROLE_CUSTOMER_UPDATE_STATUS_N2',
  ROLE_CUSTOMER_CUSTOMER_GROUP_CREATE: 'ROLE_CUSTOMER_CUSTOMER_GROUP_CREATE',
  ROLE_CUSTOMER_VAT_ZONE_CREATE: 'ROLE_CUSTOMER_VAT_ZONE_CREATE',
  ROLE_CUSTOMER_BILLING_CODE_CREATE: 'ROLE_CUSTOMER_BILLING_CODE_CREATE',
  ROLE_CUSTOMER_EDI_WHEEL_CREATE: 'ROLE_CUSTOMER_EDI_WHEEL_CREATE',
  ROLE_CUSTOMER_DMS_REF_UPDATE: 'ROLE_CUSTOMER_DMS_REF_UPDATE',
  ROLE_CUSTOMER_AUTO_VALIDATION_UPDATE: 'ROLE_CUSTOMER_AUTO_VALIDATION_UPDATE',
  ROLE_CUSTOMER_SUPPLIER_TEMPLATE_CREATE:
    'ROLE_CUSTOMER_SUPPLIER_TEMPLATE_CREATE',
  ROLE_CUSTOMER_BRAND_TEMPLATE_CREATE: 'ROLE_CUSTOMER_BRAND_TEMPLATE_CREATE',
  ROLE_CUSTOMER_SETTING_TEMPLATE_CREATE:
    'ROLE_CUSTOMER_SETTING_TEMPLATE_CREATE',
  ROLE_CUSTOMER_INTERNAL_STOCK_CREATE: 'ROLE_CUSTOMER_INTERNAL_STOCK_CREATE',
  ROLE_CUSTOMER_INTERNAL_STOCK_UPDATE: 'ROLE_CUSTOMER_INTERNAL_STOCK_UPDATE',
  ROLE_CUSTOMER_QUOTE_FORM: 'ROLE_CUSTOMER_QUOTE_FORM',
  ROLE_CUSTOMER_CONTAINER_ELIGIBILITY_CREATE:
    'ROLE_CUSTOMER_CONTAINER_ELIGIBILITY_CREATE',
  ROLE_CUSTOMER_CONTAINER_ELIGIBILITY_UPDATE:
    'ROLE_CUSTOMER_CONTAINER_ELIGIBILITY_UPDATE',

  // UPDATE CUSTOMER
  ROLE_CUSTOMER_UPDATE: 'ROLE_CUSTOMER_UPDATE',
  ROLE_CUSTOMER_CUSTOMER_GROUP_UPDATE: 'ROLE_CUSTOMER_CUSTOMER_GROUP_UPDATE',
  ROLE_CUSTOMER_VAT_ZONE_UPDATE: 'ROLE_CUSTOMER_VAT_ZONE_UPDATE',
  ROLE_CUSTOMER_BILLING_CODE_UPDATE: 'ROLE_CUSTOMER_BILLING_CODE_UPDATE',
  ROLE_CUSTOMER_EDI_WHEEL_UPDATE: 'ROLE_CUSTOMER_EDI_WHEEL_UPDATE',
  ROLE_CUSTOMER_SUPPLIER_TEMPLATE_UPDATE:
    'ROLE_CUSTOMER_SUPPLIER_TEMPLATE_UPDATE',
  ROLE_CUSTOMER_BRAND_TEMPLATE_UPDATE: 'ROLE_CUSTOMER_BRAND_TEMPLATE_UPDATE',
  ROLE_CUSTOMER_SETTING_TEMPLATE_UPDATE:
    'ROLE_CUSTOMER_SETTING_TEMPLATE_UPDATE',
  ROLE_CUSTOMER_GET: 'ROLE_CUSTOMER_GET',
  ROLE_VIEW_LOGISTIC_CONTACT_WARNING: 'ROLE_VIEW_LOGISTIC_CONTACT_WARNING',
  ROLE_CUSTOMER_LOGO_CREATE: 'ROLE_CUSTOMER_LOGO_CREATE',
  ROLE_CUSTOMER_LOGO_UPDATE: 'ROLE_CUSTOMER_LOGO_UPDATE',
  ROLE_EXPORT_DISTRIBUTION_CUSTOMERS: 'ROLE_EXPORT_DISTRIBUTION_CUSTOMERS',
  ROLE_EXPORT_DISTRIBUTION_CUSTOMERS_MODEL:
    'ROLE_EXPORT_DISTRIBUTION_CUSTOMERS_MODEL',
  ROLE_IMPORT_DISTRIBUTION_CUSTOMERS: 'ROLE_IMPORT_DISTRIBUTION_CUSTOMERS',
  ROLE_EXPORT_REDISTRIBUTION_CUSTOMERS: 'ROLE_EXPORT_REDISTRIBUTION_CUSTOMERS',
  ROLE_EXPORT_REDISTRIBUTION_CUSTOMERS_MODEL:
    'ROLE_EXPORT_REDISTRIBUTION_CUSTOMERS_MODEL',
  ROLE_IMPORT_REDISTRIBUTION_CUSTOMERS: 'ROLE_IMPORT_REDISTRIBUTION_CUSTOMERS',
  ROLE_EXPORT_PROXIMITY_STOCKS_CUSTOMERS:
    'ROLE_EXPORT_PROXIMITY_STOCKS_CUSTOMERS',
  ROLE_EXPORT_PROXIMITY_STOCKS_CUSTOMERS_MODEL:
    'ROLE_EXPORT_PROXIMITY_STOCKS_CUSTOMERS_MODEL',
  ROLE_IMPORT_PROXIMITY_STOCKS_CUSTOMERS_JOB:
    'ROLE_IMPORT_PROXIMITY_STOCKS_CUSTOMERS_JOB',
  // CRITERIA
  ROLE_CRITERIA_CREATE: 'ROLE_CRITERIA_CREATE',
  ROLE_CRITERIA_DELETE: 'ROLE_CRITERIA_DELETE',
  ROLE_CRITERIA_GET: 'ROLE_CRITERIA_GET',
  ROLE_CRITERIA_LIST: 'ROLE_CRITERIA_LIST',
  ROLE_CRITERIA_UPDATE: 'ROLE_CRITERIA_UPDATE',

  // VEHICLE TYPE GROUP

  ROLE_VEHICLE_TYPE_GROUP_DELETE: 'ROLE_VEHICLE_TYPE_GROUP_DELETE',
  ROLE_VEHICLE_TYPE_GROUP_LIST: 'ROLE_VEHICLE_TYPE_GROUP_LIST',
  ROLE_VEHICLE_TYPE_GROUP_UPDATE: 'ROLE_VEHICLE_TYPE_GROUP_UPDATE',
  ROLE_APPLICATION_SETTING_UPDATE: 'ROLE_APPLICATION_SETTING_UPDATE',
  ROLE_APPLICATION_THEME_UPDATE: 'ROLE_APPLICATION_THEME_UPDATE',

  // Supplier Template
  ROLE_SUPPLIER_TEMPLATE_GET: 'ROLE_SUPPLIER_TEMPLATE_GET',
  ROLE_SUPPLIER_TEMPLATE_LIST: 'ROLE_SUPPLIER_TEMPLATE_LIST',
  ROLE_SUPPLIER_TEMPLATE_CREATE: 'ROLE_SUPPLIER_TEMPLATE_CREATE',
  ROLE_SUPPLIER_TEMPLATE_UPDATE: 'ROLE_SUPPLIER_TEMPLATE_UPDATE',
  ROLE_SUPPLIER_TEMPLATE_DELETE: 'ROLE_SUPPLIER_TEMPLATE_DELETE',

  //  Redistribution Supplier Template
  ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_GET:
    'ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_GET',
  ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_LIST:
    'ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_LIST',
  ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_CREATE:
    'ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_CREATE',
  ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_UPDATE:
    'ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_UPDATE',
  ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_DELETE:
    'ROLE_REDISTRIBUTION_SUPPLIER_TEMPLATE_DELETE',

  // Wheel Supplier Template
  ROLE_WHEEL_SUPPLIER_TEMPLATE_GET: 'ROLE_WHEEL_SUPPLIER_TEMPLATE_GET',
  ROLE_WHEEL_SUPPLIER_TEMPLATE_LIST: 'ROLE_WHEEL_SUPPLIER_TEMPLATE_LIST',
  ROLE_WHEEL_SUPPLIER_TEMPLATE_CREATE: 'ROLE_WHEEL_SUPPLIER_TEMPLATE_CREATE',
  ROLE_WHEEL_SUPPLIER_TEMPLATE_UPDATE: 'ROLE_WHEEL_SUPPLIER_TEMPLATE_UPDATE',
  ROLE_WHEEL_SUPPLIER_TEMPLATE_DELETE: 'ROLE_WHEEL_SUPPLIER_TEMPLATE_DELETE',

  // AUTOMAKER
  ROLE_AUTOMAKER_LIST: 'ROLE_AUTOMAKER_LIST',
  ROLE_AUTOMAKER_UPDATE: 'ROLE_AUTOMAKER_UPDATE',
  // Countries
  ROLE_COUNTRY_LIST: 'ROLE_COUNTRY_LIST',
  ROLE_COUNTRY_CREATE: 'ROLE_COUNTRY_CREATE',
  ROLE_COUNTRY_DELETE: 'ROLE_COUNTRY_DELETE',
  // Languages
  ROLE_LANGUAGE_LIST: 'ROLE_LANGUAGE_LIST',
  ROLE_LANGUAGE_ADMIN: 'ROLE_LANGUAGE_ADMIN',
  ROLE_LANGUAGE_CREATE: 'ROLE_LANGUAGE_CREATE',
  ROLE_LANGUAGE_DELETE: 'ROLE_LANGUAGE_DELETE',

  // Invoicing Company
  ROLE_INVOICING_COMPANY_LIST: 'ROLE_INVOICING_COMPANY_LIST',

  // S2S Flow Template
  ROLE_S2S_FLOW_TEMPLATE_GET: 'ROLE_S2S_FLOW_TEMPLATE_GET',
  ROLE_S2S_FLOW_TEMPLATE_LIST: 'ROLE_S2S_FLOW_TEMPLATE_LIST',
  ROLE_S2S_FLOW_TEMPLATE_CREATE: 'ROLE_S2S_FLOW_TEMPLATE_CREATE',
  ROLE_S2S_FLOW_TEMPLATE_UPDATE: 'ROLE_S2S_FLOW_TEMPLATE_UPDATE',
  ROLE_S2S_FLOW_TEMPLATE_DELETE: 'ROLE_S2S_FLOW_TEMPLATE_DELETE',

  // S2S Business Rule
  ROLE_S2S_BUSINESS_RULE_LIST: 'ROLE_S2S_BUSINESS_RULE_LIST',
  ROLE_S2S_BUSINESS_RULE_GET: 'ROLE_S2S_BUSINESS_RULE_GET',
  ROLE_S2S_BUSINESS_RULE_UPDATE: 'ROLE_S2S_BUSINESS_RULE_UPDATE',

  // Setting Template
  ROLE_SETTING_TEMPLATE_GET: 'ROLE_SETTING_TEMPLATE_GET',
  ROLE_SETTING_TEMPLATE_LIST: 'ROLE_SETTING_TEMPLATE_LIST',
  ROLE_SETTING_TEMPLATE_CREATE: 'ROLE_SETTING_TEMPLATE_CREATE',
  ROLE_SETTING_TEMPLATE_UPDATE: 'ROLE_SETTING_TEMPLATE_UPDATE',
  ROLE_SETTING_TEMPLATE_DELETE: 'ROLE_SETTING_TEMPLATE_DELETE',
  // USER

  ROLE_USER_CREATE: 'ROLE_USER_CREATE',
  ROLE_USER_GET: 'ROLE_USER_GET',
  ROLE_USER_LIST: 'ROLE_USER_LIST',
  ROLE_USER_UPDATE: 'ROLE_USER_UPDATE',
  ROLE_USER_UPDATE_STATUS: 'ROLE_USER_UPDATE_STATUS',
  ROLE_USER_GET_WYZ_ROLES: 'ROLE_USER_GET_WYZ_ROLES',
  ROLE_USER_UNLOCK: 'ROLE_USER_UNLOCK',
  ROLE_USER_IMPORT_EXPORT: 'ROLE_USER_IMPORT_EXPORT',
  ROLE_USER_DELETE: 'ROLE_USER_DELETE',

  // Purchase
  ROLE_AUTOCOMPLETE_TYRES: 'ROLE_AUTOCOMPLETE_TYRES',
  ROLE_LIST_SEASONS: 'ROLE_LIST_SEASONS',
  ROLE_LIST_SEARCH_HISTORY: 'ROLE_LIST_SEARCH_HISTORY',
  ROLE_LIST_DIMENSIONS: 'ROLE_LIST_DIMENSIONS',
  ROLE_LIST_OFFERS: 'ROLE_LIST_OFFERS',
  ROLE_SUBMIT_CART: 'ROLE_SUBMIT_CART',
  ROLE_DELETE_CART: 'ROLE_DELETE_CART',
  ROLE_UPDATE_CART: 'ROLE_UPDATE_CART',
  ROLE_GET_CART: 'ROLE_GET_CART',

  // Orders
  ROLE_LIST_ORDERS: 'ROLE_LIST_ORDERS',
  ROLE_LIST_REDISTRIBUTION_ORDERS: 'ROLE_LIST_REDISTRIBUTION_ORDERS',
  ROLE_GET_PENDING_ORDER: 'ROLE_GET_PENDING_ORDER',
  ROLE_GET_ORDERS: 'ROLE_GET_ORDERS',
  ROLE_EXPORT_ORDERS: 'ROLE_EXPORT_ORDERS',
  ROLE_PRINT_ORDERS: 'ROLE_PRINT_ORDERS',
  ROLE_LIST_PENDING_ORDERS: 'ROLE_LIST_PENDING_ORDERS',
  ROLE_LIST_PROCESSED_ORDERS: 'ROLE_LIST_PROCESSED_ORDERS',
  ROLE_GET_PROCESSED_ORDER: 'ROLE_GET_PROCESSED_ORDER',
  ROLE_CANCEL_PROCESSED_ORDER: 'ROLE_CANCEL_PROCESSED_ORDER',
  ROLE_CONFIRM_PENDING_ORDER: 'ROLE_CONFIRM_PENDING_ORDER',
  ROLE_CANCEL_PENDING_ORDER: 'ROLE_CANCEL_PENDING_ORDER',
  ROLE_AUTO_VALIDATE_ORDERS: 'ROLE_AUTO_VALIDATE_ORDERS',

  // advert
  ROLE_ADVERT_CREATE: 'ROLE_ADVERT_CREATE',
  ROLE_ADVERT_DELETE: 'ROLE_ADVERT_DELETE',
  ROLE_ADVERT_GET: 'ROLE_ADVERT_GET',
  ROLE_ADVERT_LIST: 'ROLE_ADVERT_LIST',
  ROLE_ADVERT_UPDATE: 'ROLE_ADVERT_UPDATE',

  // Quote
  ROLE_QUOTE_LIST: 'ROLE_QUOTE_LIST',
  ROLE_QUOTE_CREATE: 'ROLE_QUOTE_CREATE',
  ROLE_QUOTE_UPDATE: 'ROLE_QUOTE_UPDATE',
  ROLE_QUOTE_DELETE: 'ROLE_QUOTE_DELETE',
  ROLE_QUOTE_SEND_MAIL: 'ROLE_QUOTE_SEND_MAIL',

  // Diagnoses
  ROLE_DIAGNOSIS_LIST: 'ROLE_DIAGNOSIS_LIST',

  // logs
  ROLE_AUDIT_LOG_LIST: 'ROLE_AUDIT_LOG_LIST',

  // Quote PP
  ROLE_QUOTE_PRICING_POLICY_GET: 'ROLE_QUOTE_PRICING_POLICY_GET',
  ROLE_QUOTE_PRICING_POLICY_LIST: 'ROLE_QUOTE_PRICING_POLICY_LIST',
  ROLE_QUOTE_PRICING_POLICY_CREATE: 'ROLE_QUOTE_PRICING_POLICY_CREATE',
  ROLE_QUOTE_PRICING_POLICY_UPDATE: 'ROLE_QUOTE_PRICING_POLICY_UPDATE',
  ROLE_QUOTE_PRICING_POLICY_DELETE: 'ROLE_QUOTE_PRICING_POLICY_DELETE',
  ROLE_QUOTE_PRICING_POLICY_DUPLICATE: 'ROLE_QUOTE_PRICING_POLICY_DUPLICATE',

  // Quote Service pricing policies
  ROLE_QUOTE_SERVICE_PRICING_POLICY_GET:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_GET',
  ROLE_QUOTE_SERVICE_PRICING_POLICY_LIST:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_LIST',
  ROLE_QUOTE_SERVICE_PRICING_POLICY_CREATE:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_CREATE',
  ROLE_QUOTE_SERVICE_PRICING_POLICY_UPDATE:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_UPDATE',
  ROLE_QUOTE_SERVICE_PRICING_POLICY_DELETE:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_DELETE',
  ROLE_QUOTE_SERVICE_PRICING_POLICY_DUPLICATE:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_DUPLICATE',
  ROLE_QUOTE_SERVICE_PRICING_POLICY_SETTINGS:
    'ROLE_QUOTE_SERVICE_PRICING_POLICY_SETTINGS',

  // redistribution pricing policies
  ROLE_REDISTRIBUTION_PRICING_POLICY_GET:
    'ROLE_REDISTRIBUTION_PRICING_POLICY_GET',
  ROLE_REDISTRIBUTION_PRICING_POLICY_LIST:
    'ROLE_REDISTRIBUTION_PRICING_POLICY_LIST',
  ROLE_REDISTRIBUTION_PRICING_POLICY_CREATE:
    'ROLE_REDISTRIBUTION_PRICING_POLICY_CREATE',
  ROLE_REDISTRIBUTION_PRICING_POLICY_UPDATE:
    'ROLE_REDISTRIBUTION_PRICING_POLICY_UPDATE',
  ROLE_REDISTRIBUTION_PRICING_POLICY_DELETE:
    'ROLE_REDISTRIBUTION_PRICING_POLICY_DELETE',
  // Redistribution Service pricing policies
  ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_GET:
    'ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_GET',
  ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_LIST:
    'ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_LIST',
  ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_CREATE:
    'ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_CREATE',
  ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_UPDATE:
    'ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_UPDATE',
  ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_DELETE:
    'ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_DELETE',
  ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_DUPLICATE:
    'ROLE_REDISTRIBUTION_SERVICE_PRICING_POLICY_DUPLICATE',

  // Destocking pricing policies
  ROLE_DESTOCKING_PRICING_POLICY_GET: 'ROLE_DESTOCKING_PRICING_POLICY_GET',
  ROLE_DESTOCKING_PRICING_POLICY_LIST: 'ROLE_DESTOCKING_PRICING_POLICY_LIST',
  ROLE_DESTOCKING_PRICING_POLICY_CREATE:
    'ROLE_DESTOCKING_PRICING_POLICY_CREATE',
  ROLE_DESTOCKING_PRICING_POLICY_UPDATE:
    'ROLE_DESTOCKING_PRICING_POLICY_UPDATE',
  ROLE_DESTOCKING_PRICING_POLICY_CLOSE: 'ROLE_DESTOCKING_PRICING_POLICY_CLOSE',

  // Quote cart
  ROLE_QUOTE_CART_GET: 'ROLE_QUOTE_CART_GET',
  ROLE_QUOTE_CART_UPDATE: 'ROLE_QUOTE_CART_UPDATE',
  ROLE_QUOTE_CART_UPDATE_PRICE: 'ROLE_QUOTE_CART_UPDATE_PRICE',
  ROLE_QUOTE_CART_DELETE: 'ROLE_QUOTE_CART_DELETE',
  ROLE_QUOTE_CART_SUBMIT: 'ROLE_QUOTE_CART_SUBMIT',

  // Redistribution
  ROLE_LIST_REDISTRIBUTION_OFFERS: 'ROLE_LIST_REDISTRIBUTION_OFFERS',
  ROLE_GET_REDISTRIBUTION_CART: 'ROLE_GET_REDISTRIBUTION_CART',
  ROLE_UPDATE_REDISTRIBUTION_CART: 'ROLE_UPDATE_REDISTRIBUTION_CART',
  ROLE_DELETE_REDISTRIBUTION_CART: 'ROLE_DELETE_REDISTRIBUTION_CART',
  ROLE_SUBMIT_REDISTRIBUTION_CART: 'ROLE_SUBMIT_REDISTRIBUTION_CART',
  ROLE_REDISTRIBUTION_CART_SUBMIT: 'ROLE_REDISTRIBUTION_CART_SUBMIT',
  ROLE_CREATE_CALL_CENTER_ORDER: 'ROLE_CREATE_CALL_CENTER_ORDER',

  // Quote Settings
  ROLE_QUOTE_SETTING_GET: 'ROLE_QUOTE_SETTING_GET',
  ROLE_QUOTE_SETTING_UPDATE: 'ROLE_QUOTE_SETTING_UPDATE',
  ROLE_QUOTE_SETTING_DUPLICATE: 'ROLE_QUOTE_SETTING_DUPLICATE',

  ROLE_DEFAULT_QUOTE_PRICING_POLICY_CREATE:
    'ROLE_DEFAULT_QUOTE_PRICING_POLICY_CREATE',
  ROLE_DEFAULT_QUOTE_PRICING_POLICY_LIST:
    'ROLE_DEFAULT_QUOTE_PRICING_POLICY_LIST',
  ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_LIST:
    'ROLE_DEFAULT_QUOTE_PRICING_POLICY_LIST',
  ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_CREATE:
    'ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_CREATE',
  ROLE_DEFAULT_QUOTE_PRICING_POLICY_GET:
    'ROLE_DEFAULT_QUOTE_PRICING_POLICY_GET',
  ROLE_DEFAULT_QUOTE_PRICING_POLICY_UPDATE:
    'ROLE_DEFAULT_QUOTE_PRICING_POLICY_UPDATE',
  ROLE_DEFAULT_QUOTE_PRICING_POLICY_DELETE:
    'ROLE_DEFAULT_QUOTE_PRICING_POLICY_DELETE',
  ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_GET:
    'ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_GET',
  ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_UPDATE:
    'ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_UPDATE',
  ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_DELETE:
    'ROLE_DEFAULT_QUOTE_SERVICE_PRICING_POLICY_DELETE',

  // Container Supplier
  ROLE_CONTAINER_SUPPLIER_LIST: 'ROLE_CONTAINER_SUPPLIER_LIST',
  ROLE_CONTAINER_SUPPLIER_GET: 'ROLE_CONTAINER_SUPPLIER_GET',

  // Container Pricing Policy
  ROLE_CONTAINER_PRICING_POLICY_CREATE: 'ROLE_CONTAINER_PRICING_POLICY_CREATE',
  ROLE_CONTAINER_PRICING_POLICY_LIST: 'ROLE_CONTAINER_PRICING_POLICY_LIST',

  // Container Buyer
  ROLE_CONTAINER_ORDER_CREATE: 'ROLE_CONTAINER_ORDER_CREATE',
  ROLE_CONTAINER_ORDER_LIST: 'ROLE_CONTAINER_ORDER_LIST',
  ROLE_CONTAINER_PRICING_POLICY_UPDATE: 'ROLE_CONTAINER_PRICING_POLICY_UPDATE',

  // Container order for suppliers
  ROLE_SUPPLIER_CONTAINER_ORDER_LIST: 'ROLE_SUPPLIER_CONTAINER_ORDER_LIST',
  // Diagnosis Access
  ROLE_DEBUG_REPORT_GET: 'ROLE_DEBUG_REPORT_GET',
  ROLE_LOCO_TRANSLATION: 'ROLE_LOCO_TRANSLATION',

  // Distribution Pricing Policy Param
  ROLE_LIST_DISTRIBUTION_PRICING_POLICY:
    'ROLE_LIST_DISTRIBUTION_PRICING_POLICY',
  ROLE_UPDATE_DISTRIBUTION_PRICING_POLICY:
    'ROLE_UPDATE_DISTRIBUTION_PRICING_POLICY',
};

export const isGranted = (
  userRoles: Array<string>,
  requiredRoles?: Array<string>,
  strategy: AccessDecisionStrategy = 'unanimous',
) => {
  if (userRoles.includes(ROLES.ROLE_SUPER_ADMIN)) {
    return true;
  }
  if (strategy === 'unanimous') {
    return (requiredRoles || []).every((role) => userRoles.includes(role));
  } else if (strategy == 'affirmative')
    return (requiredRoles || []).some((role) => userRoles.includes(role));
  else {
    throw new Error(`${JSON.stringify(strategy)} not implemented`);
  }
};
